import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import DropDownListViewModelType from '@/ViewModels/Controls/DropDownListViewModel';
import DropDownListType from '@/Controls/DropDownList';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';

export default class DropDownListFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelType>('DropDownListViewModel');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: DropDownListType;
    /**
     * @override
     */
    viewModel: DropDownListViewModelType;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        if (!this.viewModel) {
            this.viewModel = this.detailViewItem.viewModel || this.createViewModel(this.createViewModelParameter());
            this.defineSubscription((this.viewModel as DropDownListViewModelType).value, this.onChange.bind(this));
        }

        this.control = new this.DropDownList(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    /**
     * Creates the viewmodel
     */
    protected createViewModel(params: object): DropDownListViewModelType {
        return new this.DropDownListViewModel(params);
    }

    /**
     * Creates the parameter for viewmodel
     */
    protected createViewModelParameter(): any {
        return {
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            data: this.getData(),
            dataValueField: this.getDataValueField(),
            dataTextField: this.getDataTextField(),
            isSummaryViewMode: this.isSummaryViewMode,
            value: this.getValue(),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            onOpen: this.onOpen.bind(this)
        }
    }

    /**
    * Wird ausgeführt, wenn sich der Wert ändert
    */
    protected onChange(value: any): void {

    }

    /**
    * Wird ausgeführt, wenn das DropDown geöffnet wird
    */
    protected onOpen(): void {

    }

    /**
    * Liefert ein Observable, in dem sich die verfügbaren Einträge befinden
    */
    protected getData(): KnockoutObservable<any[]> {
        return this.context.genericObject.getObservable(this.detailViewItem.name + '.Data', []);
    }

    /**
    * Liefert den Namen des Feldes, in dem sich der Wert eines Eintrags befinden
    */
    protected getDataValueField(): string {
        return null;
    }

    /**
    * Liefert den Namen des Feldes, in dem sich der Bezeichner eines Eintrags befinden
    */
    protected getDataTextField(): string {
        return null;
    }

    /**
    * Liefert ein Observable, in dem sich der aktuelle Wert befindet
    */
    protected getValue(): KnockoutObservable<any> {
        return this.context.genericObject.getObservable(this.detailViewItem.name);
    }

}

ComponentManager.setFactory('DropDownList', DropDownListFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');